import { cn } from '@commenda/utils';

export const DocumentSummaryField = ({
  onClick,
  title,
  className,
}: {
  onClick: () => void;
  title: string;
  className?: string;
}) => {
  return (
    <div className={cn('flex items-start py-1 gap-4', className)}>
      <span className="text-sm text-text-secondary flex-shrink-0 w-1/3">
        {title}
      </span>
      <span
        onClick={onClick}
        className="text-sm font-medium text-utility-blue-500 cursor-pointer"
      >
        Open document
      </span>
    </div>
  );
};
